import { shape, string } from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import { withDocumentTitle } from '../generic/DocumentTitle';
import Titled from '../layout/Titled';
import api from '../REST/api';
import DeleteButton from '../REST/DeleteButton';
import update from '../REST/update';
import { tapFlashSuccess } from '../utils/flash';
import ContactForm from './ContactForm';
import {
  getTransformedContact,
  transformForPatch,
  transformForRendering,
} from './transform-contact-helpers';
import { fullName } from './utils';

const UpdateContactForm = update({
  query: getTransformedContact,
  deriveQueryArgs: ({ id }) => ({ id }),
  update: ({ id }, changedModel) =>
    api
      .patchContact({
        id,
        data: transformForPatch(changedModel),
      })
      .then(transformForRendering)
      .then(tapFlashSuccess('Contact update successful')),
  form: withDocumentTitle(({ model }) => fullName(model))(ContactForm),
  redirectTo: '/contacts/:id/show',
});

function UpdateContact({ match }) {
  const id = Number.parseInt(match.params.id, 10);

  return (
    <Titled
      title="Edit Contact"
      actions={[
        <DeleteButton
          onDelete={api.destroyContact}
          id={id}
          name="Contact"
          redirectTo="/contacts"
        />,
        <Link to="show" className="btn btn-secondary ml-2">
          Show
        </Link>,
      ]}
      sticky
    >
      <UpdateContactForm id={id} />
    </Titled>
  );
}

UpdateContact.propTypes = {
  match: shape({ params: shape({ id: string.isRequired }).isRequired })
    .isRequired,
};

export default UpdateContact;
